import { Pipe, PipeTransform } from '@angular/core';
import { CmsService } from 'modules/shared/services/cms.service';

@Pipe({
  name: 'offerfilter',
})
export class OfferfilterPipe implements PipeTransform {
  constructor(
    public cmsService: CmsService // public cmsService: CmsService
  ) {}
  transform(items: any[], filter: string, casinoOffer: any[], blockedOfferList: any[], blockedCasinoOfferList: any[]): any {
    const isPlayerLoggedIn = this.cmsService.isPlayerLogin.value;
    let basOffer = items;
    let casOffer = isPlayerLoggedIn ? casinoOffer : [];
    let blockedOffers = blockedOfferList || [];
    let blockedCasinoOffers = blockedCasinoOfferList || [];

    if (!filter) {
      return casOffer.concat(basOffer);
    } else {
      let offerList = casOffer.concat(basOffer).concat(blockedOffers).concat(blockedCasinoOffers);
      let offerRes = offerList.filter((item) => {
        return item.offer.toLowerCase() === filter.toLowerCase();
      });
      return offerRes && offerRes.length > 0 ? (offerRes.length == 1 ? offerRes : offerRes.splice(1)) : [];
    }
  }
}
